import type {
  DocumentPayload,
  LastOCRRequestParams,
  LastOCRRequest,
} from '@app/application/ai_ocr_requests/types'
import { isLastOCRRequestParamsByAccountId } from '../predicates'

import SFetch from '@app/utils/sfetch'

export const retrieveLastOCRRequestStatus = (
  params: LastOCRRequestParams
): Promise<LastOCRRequest | null> => {
  const pickedParams = isLastOCRRequestParamsByAccountId(params)
    ? {
        ledger_id: params.ledgerId,
        account_id: params.accountId,
      }
    : {
        ledger_id: params.ledgerId,
        reconciliation_text_id: params.reconciliationTextId,
      }

  const url =
    window.Silverfin.Routes.retrieve_latest_for_context_ai_ocr_requests_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      pickedParams
    )

  return SFetch.json<LastOCRRequest>(url, {
    method: 'GET',
  })
}

export const ackFailedAiOCRRequest = (
  aiOcrRequestId: string
): Promise<null> => {
  const url = window.Silverfin.Routes.ack_failed_request_ai_ocr_request_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    aiOcrRequestId
  )

  return SFetch.json(url, { method: 'POST' })
}

export const saveOCRDocuments = ({
  ledgerId,
  accountId,
  reconciliationTextId,
  payload,
}: {
  ledgerId: number
  accountId: number
  reconciliationTextId: number
  payload: DocumentPayload[]
}): Promise<{
  channel: string
  lastId: number
  aiOcrRequestId: string
} | null> => {
  const url = window.Silverfin.Routes.ai_ocr_requests_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return SFetch.json<{
    channel: string
    lastId: number
    aiOcrRequestId: string
  }>(url, {
    method: 'POST',
    body: {
      ai_ocr_request: {
        ledger_id: ledgerId,
        reconciliation_text_id: reconciliationTextId,
        account_id: accountId,
        documents: payload,
      },
    },
  })
}
